<template>
  <div class="tabData">
    <el-table
      border
      :data="coupons"
      style="width: 100%;text-align: center">
      <el-table-column
        prop="coupon_name"
        label="優惠劵名稱"
        width="180">
      </el-table-column>
      <el-table-column
        prop="worth"
        label="優惠劵金額"
        width="180">
      </el-table-column>
      <el-table-column
        prop="pay"
        label="使用門檻">
      </el-table-column>
      <el-table-column
        label="狀態">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">可用</span>
          <span v-if="scope.row.status == 2">已使用</span>
          <span v-if="scope.row.status == 3">已失效</span>
        </template>
      </el-table-column>
      <el-table-column
        width="320"
        label="日期">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 2">{{scope.row.used_time}}</span>
          <span v-else>{{scope.row.start_time}}至{{scope.row.end_time}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

  export default {
    name: 'TabData',
    props:['coupons'],
    data () {
      return {
        tableData: [{
          type:'抵现',
          num:'0123456',
          money:'38',
          state:'可用',
          moneyMin:'10',
          data:'2018-10-05 至 2018-10-06'
        }]

      }
    },
    created(){
    },
    methods:{

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .rightList-head{
    display: block;
    overflow: hidden;
    padding: 0 18px;
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/pages/personalPage/assetCenterPage/TabData.vue